import type {CustomStepProps} from '../../../lib/sign-catalog'
import {FoniRowEditor} from '../../foni'

export function ContentStep({input, onChange}: CustomStepProps) {
    return (
        <FoniRowEditor
            rows={input.rows}
            onChange={rows => onChange({rows})}
        />
    )
}
